<template>
    <layout>
    	<div class="row">
            <div class="col-sm-12">
                <NotiificationList
                    :moduleCode="moduleCode"
                    :panelId="pageID"
                    :url="url.getList"
                    :canDetail="canDetail"
                    :canAdd="canAdd"
                    :canEdit="canEdit"
                    :canDelete="canDelete"
                    :routeEdit="`${moduleCode}.${pageID}.show`"
                    :modules="lists.modules"
                    :channels="lists.channels"
                />
			</div>
    	</div>
    </layout>
</template>

<script>
	import GeneralMixin from '../../mixin'

    export default {
        mixins: [
            GeneralMixin
        ],
        components: {
            NotiificationList: () => import(/* webpackChunkName: "notification-history" */ '@/app/shared/components/notification/history/NotiificationList'),
        },
    	data() {
            let pageID = 'database_notifications';
      		return {
                pageID: pageID,
                lists: {
                    modules: [],
                    channels: [],
                }
      		}
    	},
        mounted() {
            this.loadLists();
        },
    	methods: {
    	}
  	}
</script>
